import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-219" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-220" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-221" data-mp="mzgb791vxjxd">
        <span className="h-1 w-10 rounded-full bg-slate-600" data-id="element-222" data-mp="i6ww27njugqg" />
        <span className="h-1 w-3 rounded-full bg-amber-400" data-id="element-223" data-mp="d8lok3kq8ibe" />
      </span>
    </div>;
}